module.exports = __webpack_public_path__ + "img/Frame 793one.62cc27be.png";